import { Provider } from '@angular/core';
import { SUPABASE_CONFIG, SupabaseConfig } from './supabase.config';
import { SupabaseCore } from './supabase.core';
import { SupabaseDatabase } from './supabase.database';
import { SupabaseFunctions } from './supabase.functions';
import { SupabaseSession } from './supabase.session';
import { SupabaseStorage } from './supabase.storage';

export function provideSupabase(config: SupabaseConfig): Provider[] {
  return [
    {
      provide: SUPABASE_CONFIG,
      useValue: config,
    },
    SupabaseCore,
    SupabaseDatabase,
    SupabaseStorage,
    SupabaseSession,
    SupabaseFunctions,
  ];
}
